import { Component, OnInit, Input, OnDestroy,  Output, EventEmitter, AfterContentInit } from '@angular/core';

import { FechasService } from 'src/app/services/fechas/fechas';
import { ImprimiService } from 'src/app/services/imprimir/imprimirService';
import { FirmaService } from 'src/app/services/firma/firmaService';
import { estilos_informes } from 'src/app/config/estilos-informes';
import { logo } from 'src/app/config/imagenes';
import { ImageBaseService } from 'src/app/services/imagenes/imagenes.service';
import { urlUpload } from 'src/app/config/config';
import { ImprimirMultipleService } from 'src/app/services/imprimirMultiples/imprimirMultipleService';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';


// (<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;

declare var $: any;



@Component({
    selector: 'app-imprimir-pdf-component',
    templateUrl: './imprimir-pdf.component.html',
    styleUrls: ['./imprimir-pdf.component.css'],
    providers: [ImprimiService, FirmaService]

})
export class ImprimirPdfComponent implements OnInit, OnDestroy,  AfterContentInit {
    ngAfterContentInit(): void {
        //this.convertImagesToBase64();
    }



    @Input() title: string;
    @Input() id: string;
    @Input() database: string;
    @Input() items: any;
    @Output() cerrarVentana = new EventEmitter();


    public anexo = new Date();
    public productos: any = [];
    public oldId = "";
    public oldDatabase = "";
    public productosKey: any[] = [];
    public estructurado: any[] = [];
    public fechaActual = this.fechaService.mostrarFechaActual();
    public closeWindow = true;
    public firma = "";
    public firma2 = "";
    public baseUrl = urlUpload + "firmas/";
    public loading = true;
    public logo = '';
    public procedimiento: string = '';
    public numero_anexo: string = '';
    public fecha: any = [];
    public field: string = '';

    constructor(
        private fechaService: FechasService,
        private imprimirMultipleServcie: ImprimirMultipleService,
        private ImageBaseService: ImageBaseService
    ) {
        this.ImageBaseService.image64(logo).toPromise()
            .then((resp: string) => {

                this.logo = resp;
            }).catch(error => {
                this.logo = logo;
            })
    }

    ngOnInit(): void {

        /*   this.ImageBaseService.image64(logo).toPromise()
          .then( (resp: string) => {
             
              this.logo = resp;
          }).catch( error => {
              this.logo = logo;
          }); */

        this.mostrarContenido();


    }
    ngOnDestroy(): void {

    }
   

    mostrarContenido() {

        this.loading = true;
        this.imprimirMultipleServcie.mostrarProductos.subscribe(resp => {
            //console.log("respuesta ",resp.productos);
            this.productos = resp.productos;
            // this.MostrarAnexo();
            // this.mostrarFirma();
        }, error => {
            console.log("error", error);

        });



        this.loading = false;
    }
    jsUcfirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }


    Export2Doc() {
        // this.convertImagesToBase64();

        var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title>"
            + "<style>" + estilos_informes + " .informe-imprimir{ width:600px !important}</style>"
            + "</head><body > <div style=' font-family: Arial !important;'>";
        var postHtml = "</div></body></html>";
        var html = preHtml + document.getElementById('source-html').innerHTML + postHtml;

        var blob = new Blob(['\ufeff', html], {
            type: 'application/msword'
        });

        // Specify link url
        var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
        let filename = "";
        // Specify file name
        filename = filename ? filename + '.doc' : 'contenido zumo e IM.doc';

        // Create download link element
        var downloadLink = document.createElement("a");

        document.body.appendChild(downloadLink);

        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            // Create a link to the file
            downloadLink.href = url;

            // Setting the file name
            downloadLink.download = filename;

            //triggering the function
            downloadLink.click();
        }

        document.body.removeChild(downloadLink);
    }

    generatePdf() {
    
        /* 
        contrato: "C20/0054"
fecha: "15/09/2020"
id: "443"
observaciones: ""
partida: "COVATELLES"
propietario: "PLANELLS PEREZ,MARIA REMEDIOS"
responsable: "ENCARNA PRATS"
revision: null
termino: "TORRENT"
variedad
        */
       // console.log('items', this.items);
        let contentTable: any[] = [];
        for (let index = 0; index < this.items.length; index++) {

            if( (index % 2) == 0) {
                const element =   [
                    { text: this.items[index]['contrato'], style: 'columnColor' },
                    { text: this.items[index]['variedad'], style: 'columnColor' },
                    { text: this.items[index]['propietario'], style: 'columnColor' },
                    { text: this.items[index]['termino'], style: 'columnColor' },
                   ] ;
                contentTable[index + 1]= element;
            } else {
                const element =   [
                    { text: this.items[index]['contrato'] },
                    { text: this.items[index]['variedad'] },
                    { text: this.items[index]['propietario'] },
                    { text: this.items[index]['termino'] },
                   ] ;
                contentTable[index + 1] = element;
            }
            
        }
        contentTable[0] = [
            { text: 'CONTRATO', style: 'headerTable'},
            { text: 'VARIEDAD', style: 'headerTable'}, 
            { text: 'PROPIETARIO', style: 'headerTable'}, 
            { text: 'TÉRMINO', style: 'headerTable'} 
          ];
        //console.log('contentTable', contentTable);
      
       
     
        var docDefinition:any = {
            content: [
              { 
                style: 'tableExample',
                table: {
                widths: [100, '*'],
                body: [
                    [
                        {image: this.logo, width: 100 }, {text: 'CUADERNO DE CAMPO', style: 'headerTitle', alignment: 'center'}
                      ],
                ] 
              }
            },
              {
                style: 'tableExample',
                table: {
                  widths: [100, '*', 200, '*'],
                  /* body: [
                    ['Contrato','Variedad','Propietario','Término'],
                    contentTable[0],
                    ['fixed-width cells have exactly the specified width',
                      {
                        text: 'nothing interesting here', 
                        italics: true, 
                        fillColor: '#a5c2f0',
                        bold: true,
                        color: 'black',
                        border: [true, true, true, true],
                      },
                      { text: 'nothing interesting here', italics: true, color: 'gray', fillColor: '#a5c2f0' },
                      { text: 'nothing interesting here', italics: true, color: 'gray', fillColor: '#a5c2f0' }
                    ]
                  ], */
                  body: contentTable
      
                }
              },
              
            ],
            styles: {
              tableExample: {
                margin: [0, 5, 0, 15],
                // fillColor:'blue',
                // color: 'white'
      
              },
              headerTitle: {
                margin: [0, 20, 0, 15],
                fontSize: 20
                // fillColor:'blue',
                // color: 'white'
              },
              headerTable: {
                //fontSize: 20
                 fillColor:'#e0dede',
                // color: 'white'
              },
              columnColor: {
                fillColor: '#a5c2f0'
              }
            }
          };
      
      
         
          pdfMake.createPdf(docDefinition).print({}, window.frames['printPdf']);
        
    }


    cerrar() {
        this.cerrarVentana.emit({ closeWindow: false });
    }

}